'use client';
import { HamburgerMenuLinkProps, HamburgerMenuLink } from './HamburgerMenuLink';
import { TypeLaunchDarklyVariationContainerFields } from '@/core/generated-types';
import useFeatureContent from '@/hooks/useFeatureContent';

export const VariationHamburgerMenuLink = (props: HamburgerMenuLinkProps) => {
  const { menuItem } = props;
  const fields = menuItem.fields as TypeLaunchDarklyVariationContainerFields;
  const content = useFeatureContent({ ...fields });

  if (!content) return null;

  return <HamburgerMenuLink {...props} menuItem={content} />;
};
